import React from 'react';
import Contact from './Contact';
import PageMeta from './PageMeta';

const ContactUs = () => {
  return (
    <div className="bg-phoenix-beige min-h-screen py-20">
      <PageMeta
        title="Contact Us | Phoenix Dental"
        description="Get in touch with Phoenix Dental to schedule your appointment. Find our location, phone number, and hours."
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-phoenix-gold mb-12 text-center">Contact Us</h1>
        <Contact />
      </div>
    </div>
  );
};

export default ContactUs;
